export type OpportunitySource = 'upcoming-projects' | 'renewable-proposals';

export const CONTROL_COMPLETED_STATUS_ID = 4;

export const getProposalStatusId = (proposal: any): number | null => {
  const rawStatusId = proposal?.statusId ?? proposal?.status_id ?? proposal?.status?.id;
  const statusId = Number(rawStatusId);

  return Number.isFinite(statusId) ? statusId : null;
};

export const isControlCompletedProposal = (proposal: any): boolean =>
  getProposalStatusId(proposal) === CONTROL_COMPLETED_STATUS_ID;

export const buildOpportunityProposalCreateLink = (
  proposalId: number | string | Array<number | string>,
  source: OpportunitySource
): string => {
  const proposalIds = Array.isArray(proposalId) ? proposalId : [proposalId];
  const normalizedProposalIds = proposalIds
    .map((id) => String(id).trim())
    .filter(Boolean);
  const params = new URLSearchParams();

  if (normalizedProposalIds.length === 1) {
    params.set('proposalId', normalizedProposalIds[0]);
  } else {
    params.set('proposalIds', normalizedProposalIds.join(','));
  }
  params.set('mode', 'renew');

  if (source === 'upcoming-projects') {
    params.set('source', source);
  }

  return `/proposals/create?${params.toString().replace(/%2C/g, ',')}`;
};
